module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":{"username":"Username","password":"Password","login":"Login"}},"sk":{"login":{"username":"Užívateľské meno","password":"Heslo","login":"Prihlásiť"}},"cz":{"login":{"username":"Užívatelské jméno","password":"Heslo","login":"Přihlásit"}},"de":{"login":{"username":"Nutzername","password":"Passwort","login":"Anmeldung"}}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./static/localization/login.json
// module id = 141
// module chunks = 1